// Komunikat błędu z odpowiedzi BE (BaseController.Error): ErrorResponse { ErrorCodes[{Message}] }
// albo ErrorResponse z polem Message; bez założeń o wielkości liter (JsonResult vs. STJ).
export const radixErrorText = (e: unknown, fallback: string): string => {
  const data = (e as { response?: { data?: Record<string, unknown> } })?.response?.data;
  if (!data) return fallback;

  const codes = (data.ErrorCodes ?? data.errorCodes) as { Message?: string; message?: string }[] | undefined;
  if (Array.isArray(codes) && codes.length > 0) {
    const text = codes.map((c) => c.Message ?? c.message).filter(Boolean).join(", ");
    if (text) return text;
  }

  const message = (data.Message ?? data.message) as string | undefined;
  return message || fallback;
};
